"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.shouldShowScheduleAppointmentsSectionOnMobile = exports.normalizeUrl = void 0;
const types_1 = require("./types");
function normalizeUrl(url) {
    return url.endsWith('/') ? url : `${url}/`;
}
exports.normalizeUrl = normalizeUrl;
function shouldShowScheduleAppointmentsSectionOnMobile(bookingStrategy) {
    switch (bookingStrategy) {
        case types_1.BookingStrategies.Availability:
            return true;
        case types_1.BookingStrategies.OpenSchedulingWidget:
            return true;
        case types_1.BookingStrategies.Button:
            return false;
        default:
            return false;
    }
}
exports.shouldShowScheduleAppointmentsSectionOnMobile = shouldShowScheduleAppointmentsSectionOnMobile;
//# sourceMappingURL=utilities.js.map